/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import classnames from 'classnames';
import Select from 'react-select';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import Sidebar from '@components/sidebar';
import { selectThemeColors } from '@src/utility/Utils';
import { FilterData } from './FilterData';

type FilterAuditProps = {
  filterData: Partial<FilterData>;
  isShowFilter: boolean;
  onClearFilterData: () => void;
  onSubmitFilter: (formValues: FilterData) => void;
  toggleShowFilter: () => void;
};

export const FilterAudit: React.FC<FilterAuditProps> = ({
  isShowFilter,
  onClearFilterData,
  onSubmitFilter,
  toggleShowFilter,
  filterData,
}) => {
  const [id, setId] = useState(filterData.id || '');
  const [userName, setUserName] = useState(filterData.userName || '');
  const [functionality, setFunctionality] = useState(
    filterData.functionality || ''
  );
  const [actionPath, setActionPath] = useState(filterData.actionPath || '');
  const [actionType, setActionType] = useState(filterData.actionType || '');
  const [createAt, setCreateAt] = useState(filterData.createAt || '');
  const [email, setEmail] = useState(filterData.email || '');
  const [systemOrigin, setSystemOrigin] = useState(
    filterData.systemOrigin || ''
  );

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmitFilter({
      id,
      userName,
      functionality,
      actionPath,
      actionType,
      createAt,
      email,
      systemOrigin,
    } as any);
  };

  const handleClear = () => {
    setId('');
    setUserName('');
    setFunctionality('');
    setActionPath('');
    setActionType('');
    setCreateAt('');
    setEmail('');
    setSystemOrigin('');
    onClearFilterData();
  };

  return (
    <Sidebar
      size="lg"
      open={isShowFilter}
      title="Filtrar por"
      headerClassName="mb-1"
      contentClassName="p-0"
      toggleSidebar={toggleShowFilter}
    >
      <Form onSubmit={handleSubmit}>
        {/* Campo ID */}
        <FormGroup>
          <Label for="id" className="form-label">
            ID
          </Label>
          <Input
            type="text"
            value={id}
            onChange={(e) => setId(e.target.value)}
            className={classnames({ 'is-invalid': false })}
          />
        </FormGroup>

        {/* Campo Nome do Usuário */}
        <FormGroup>
          <Label for="userName" className="form-label">
            Nome do Usuário
          </Label>
          <Input
            type="text"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            className={classnames({ 'is-invalid': false })}
          />
        </FormGroup>

        {/* Campo Email */}
        <FormGroup>
          <Label for="email" className="form-label">
            Email
          </Label>
          <Input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={classnames({ 'is-invalid': false })}
          />
        </FormGroup>

        {/* Campo Origem do Sistema */}
        <FormGroup>
          <Label for="systemOrigin" className="form-label">
            Origem do Sistema
          </Label>
          <Input
            type="text"
            value={systemOrigin}
            onChange={(e) => setSystemOrigin(e.target.value)}
            className={classnames({ 'is-invalid': false })}
          />
        </FormGroup>

        {/* Campo Funcionalidade */}
        <FormGroup>
          <Label for="functionality" className="form-label">
            Funcionalidade
          </Label>
          <Input
            type="text"
            value={functionality}
            onChange={(e) => setFunctionality(e.target.value)}
            className={classnames({ 'is-invalid': false })}
          />
        </FormGroup>

        {/* Campo Caminho da Ação */}
        <FormGroup>
          <Label for="actionPath" className="form-label">
            Caminho da Ação
          </Label>
          <Input
            type="text"
            value={actionPath}
            onChange={(e) => setActionPath(e.target.value)}
            className={classnames({ 'is-invalid': false })}
          />
        </FormGroup>

        {/* Campo Tipo de Ação */}
        <FormGroup>
          <Label for="actionType" className="form-label">
            Tipo de Ação
          </Label>
          <Input
            type="text"
            value={actionType}
            onChange={(e) => setActionType(e.target.value)}
            className={classnames({ 'is-invalid': false })}
          />
        </FormGroup>

        {/* Campo Data de Criação */}
        <FormGroup>
          <Label for="createAt" className="form-label">
            Data de Criação
          </Label>
          <Input
            type="text"
            value={createAt}
            onChange={(e) => setCreateAt(e.target.value)}
            className={classnames({ 'is-invalid': false })}
          />
        </FormGroup>

        <Button type="submit" color="primary">
          Filtrar
        </Button>
        <Button type="button" color="secondary" onClick={handleClear}>
          Limpar
        </Button>
      </Form>
    </Sidebar>
  );
};
